import React from 'react';
import PropTypes from 'prop-types';
import FormModal from "../../../components/common/modals/FormModal";
import graphql from "babel-plugin-relay/macro";
import {useFragment, useMutation} from "react-relay";
import {allIdentifierTypesDropdown, allIdentifierUseCodesDropdown} from "../../../relay/Fragments";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";
import {createOptions} from "../../../helpers/utils";

const NewFacilityIdentifierModal = ({showModal, onClose, facilityId, identifierTypes, identifierUseCodes}) => {
    const mutation = graphql`
    mutation NewFacilityIdentifierModalMutation($facilityId: ID!, $identifierTypeId: ID!, $identifierUseCodeId: ID!,
        $value: String!, $effectiveFrom: DateOnly!, $effectiveTo: DateOnly! ) {
        facility {
            createIdentifier(input: {facilityId: $facilityId, identifierTypeId: $identifierTypeId, identifierUseCode: $identifierUseCodeId,
            value: $value, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                facilityIdentifier {
                    id
                    facility {
                        identifiers {
                            ...FacilityIdentifiers_Identifiers
                        }}}}}}`
    const idTypes = createOptions(useFragment(allIdentifierTypesDropdown, identifierTypes), 'id', 'display');
    const idUseCodes = createOptions(useFragment(allIdentifierUseCodesDropdown, identifierUseCodes), 'id', 'display');
    const [commitMutation, isInFlight] = useMutation(mutation);
    const defaultValues = {
        ...newBandDefaultValues,
        facilityId: facilityId,
        identifierTypeId: '',
        identifierUseCodeId: '',
        value: '',
    };
    const schema = bandedSchema.shape({
        identifierTypeId: yup.string().required("Identifier Type is required"),
        identifierUseCodeId: yup.string().required("Identifier Use Code is required"),
        value: yup.string().required("Value is required")
    });

    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)});

    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.facility) {
                    toast.success("Identifier for Facility created")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                    onClose={onClose}
                   title={"New Identifier"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormSelect options={idTypes} controlId={"identifierTypeId"} label={"Identifier Type"} />
            <HorizontalFormSelect options={idUseCodes} controlId={"identifierUseCodeId"} label={"Identifier Use Code"} />
            <HorizontalFormInput controlId={"value"} label={"Value"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
NewFacilityIdentifierModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    facilityId: PropTypes.string.isRequired,
    identifierTypes: PropTypes.array.isRequired,
    identifierUseCodes: PropTypes.array.isRequired
}
export default NewFacilityIdentifierModal